__webpack_require__.p = "/projects/gitmind-refactor";